import { useState, useEffect } from "react";
import LogoImage from "../../../assets/images/logo.png";
import { Button, Input } from "droplr-react-ui-v2";
import "./usage-step.scss";
import { ONBOARDING_STEP } from "../../../constants/app.constants";
import DesignImage from "../../../assets/images/steps/design.svg";
import EducationImage from "../../../assets/images/steps/education.svg";
import EngineeringImage from "../../../assets/images/steps/engineering.svg";
import MarketingImage from "../../../assets/images/steps/marketing.svg";
import SalesImage from "../../../assets/images/steps/sales.svg";
import SupportImage from "../../../assets/images/steps/support.svg";
import OtherImage from "../../../assets/images/steps/other.svg";
import {
  ImageCheckboxComponent,
  ImageCheckboxItem,
} from "../../ui-components/image-checkbox/image-checkbox.component";
import { Client, JwtAuth, DroplrUser } from "droplr-client-ts";
import { getCookieFromStorage } from "../../../utils/utils";

export interface UsageStepProps {
  SetCurrentStep: Function;
  OnComplete: Function;
  GetOnboardingData: Function;
}
export const UsageStepComponent = ({
  SetCurrentStep,
  OnComplete,
  GetOnboardingData,
}: UsageStepProps): JSX.Element => {
  const [SelectedOptions, SetSelectedOptions] = useState<string[]>([]);
  const [ButtonLoading, SetButtonLoading] = useState(false);

  const CheckboxItems: ImageCheckboxItem[] = [
    {
      Image: DesignImage,
      Label: "Design",
      Value: "DESIGN",
      OnClick: () => {},
    },
    {
      Image: MarketingImage,
      Label: "Marketing",
      Value: "MARKETING",
      OnClick: () => {},
    },
    {
      Image: EducationImage,
      Label: "Education",
      Value: "EDUCATION",
      OnClick: () => {},
    },
    {
      Image: EngineeringImage,
      Label: "Engineering",
      Value: "ENGINEERING",
      OnClick: () => {},
    },
    {
      Image: SalesImage,
      Label: "Sales",
      Value: "SALES",
      OnClick: () => {},
    },
    {
      Image: SupportImage,
      Label: "Support",
      Value: "SUPPORT",
      OnClick: () => {},
    },
    {
      Image: OtherImage,
      Label: "Other",
      Value: "OTHER",
      OnClick: () => {},
    },
  ];

  const HandleOnboardingCompletion = () => {
    SetButtonLoading(true);
    const URLParams = new URLSearchParams(window.location.search);
    const Token = URLParams.get("jwtToken");
    if (Token == null) {
      console.log("No token found.");
      return;
    }

    const DroplrClient = new Client({
      baseUrl: process.env.REACT_APP_API_URL!,
      auth: new JwtAuth(Token),
    });
    DroplrClient.Users.Current().then((response) => {
      if (!response) return;
      response
        .json()
        .then((User: DroplrUser) => {
          const data = {
            onboardingData: GetOnboardingData(),
          };
          DroplrClient.Users.Update(User.id, JSON.stringify(data) as any)
            .then((_r) => {
              SetButtonLoading(false);
              SetCurrentStep(ONBOARDING_STEP.FINISH);
            })
            .catch((err: any) => {
              console.log("There was an error saving the user's data: ", err);
              SetButtonLoading(false);
              SetCurrentStep(ONBOARDING_STEP.FINISH);
            });
        })
        .catch((err: any) => {
          console.log("There was an error fetching the user's data: ", err);
          SetButtonLoading(false);
          window.location.href = process.env.REACT_APP_AUTH_URL!;
        });
    });
  };

  return (
    <>
      <div className="usage-step step-component-container fade-in">
        <div className="logo-image">
          <img src={LogoImage} alt="Droplr Logo" />
        </div>
        <div className="usage-step-title">
          And what will you be using Droplr for?
        </div>
        <div className="usage-checkbox">
          <ImageCheckboxComponent
            Items={CheckboxItems}
            Size={"small"}
            Multiselect={true}
            OnSelect={(option: any) => {
              SetSelectedOptions(option);
              OnComplete(option);
            }}
          />
        </div>
        <div className="usage-step-buttons">
          <Button
            label="Back"
            onClick={() => {
              if (GetOnboardingData().items.whoIsUsing === "PERSONAL") {
                SetCurrentStep(ONBOARDING_STEP.WHO_IS_USING);
              } else {
                SetCurrentStep(ONBOARDING_STEP.TEAM_INTRO);
              }
            }}
            variant="secondary"
          />
          <Button
            label="Finish"
            onClick={() => HandleOnboardingCompletion()}
            disabled={SelectedOptions.length === 0 || ButtonLoading}
            variant="primary"
            loading={ButtonLoading}
          />
        </div>
      </div>
    </>
  );
};
